import useStyles from "../styles";
import { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import InputGroup from "../../../components/FormComponent/InputGroup";
import Button from "../../../components/Button";
import { toast } from "react-toastify";
import { Icon } from "@iconify/react";
// import classNames from "classnames";
import { httprequest } from "../../../data/api";
import logo from "../../../assets/images/logo.svg";
import { useUpload } from "../../../hooks/useUpload";
import { SketchPicker } from "react-color";
import tinycolor from "tinycolor2";
import Modal from "../../../components/Modal";

const PROFILE_ENDPOINT = "api/v1/profile";

const BrandIdentity = ({ data }) => {
  const classes = useStyles();

  const [brandColor, setBrandColor] = useState(data?.branding?.brand_color || "#0065FF");

  const [isEditing, setIsEditing] = useState(false);
  const [selectedFile, setSelectedFile] = useState("");
  const [schoolLogo, setSchoolLogo] = useState(null);
  const [selectedStamp, setSelectedStamp] = useState("");
  const [deleteStamp, setDeleteStamp] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  const [branding, setBrandingDetails] = useState({});

  const handleDeleteStamp = () => {
    setDeleteStamp(!deleteStamp);
  };

  // const handleChangeBrandColor = (color) => {
  //   setBrandColor(color);
  //   setBrandingDetails({ ...branding, brand_color: color });
  // };
  const handleChangeBrandColor = (color) => {
    const hexColor = color.hex;
    // 0 (black) to 255 (white)
    const brightness = tinycolor(hexColor).getBrightness();

    if (brightness > 240) {
      toast.error("This color is too close to white and may harm visibility. Please choose a darker color.");

      return;
    }

    setBrandColor(hexColor);
    setBrandingDetails({ ...branding, brand_color: hexColor });
  };

  const handleIdentityChange = (e) => {
    const { name, value } = e.target;
    setBrandingDetails({ ...branding, [name]: value });
  };

  const handleFileChange = (e) => {
    // const { name } = e.target;
    if (e.target.files) setSelectedFile(e.target.files[0]);
    const binaryData = [];
    binaryData.push(e.target.files[0]);
    setSchoolLogo(URL.createObjectURL(new Blob(binaryData)));
  };
  const handleStampChange = (e) => {
    // const { name } = e.target;
    if (e.target.files) setSelectedStamp(e.target.files[0]);
    // const binaryData = [];
    // binaryData.push(e.target.files[0]);
    // setSchoolStamp(URL.createObjectURL(new Blob(binaryData)));
  };

  const handleRemoveFile = () => {
    setSelectedFile("");
    setSchoolLogo(null);
  };

  const handleRemoveSTamp = () => {
    setSelectedStamp("");
    // setSchoolStamp(null);
  };

  const getUserProfile = () => {
    httprequest.get(PROFILE_ENDPOINT).then((res) => {
      localStorage.setItem("brand_color", res?.data?.data?.branding?.brand_color || "#0065FF");
    }).catch((err) => {
      toast.error(err?.response?.message);
    });
  };

  const handleDeleteSchoolStamp = () => {
    setIsDeleting(true);

    httprequest.patch(PROFILE_ENDPOINT, { school_stamp: {} })
      .then((res) => {
        setIsDeleting(false);
        toast.success(res?.data?.message);
        handleDeleteStamp?.();

        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((err) => {
        setIsDeleting(false);
        toast.error(err?.response?.message || "Something went wrong");
      });
  };

  const handleBrandUpdate = async () => {
    setIsEditing(true);

    try {
      const updatedBranding = { ...branding };

      // --- If no files selected, just update branding directly ---
      if (!selectedFile && !selectedStamp) {
        const res = await httprequest.patch(PROFILE_ENDPOINT, { branding: updatedBranding });
        setIsEditing(false);
        toast.success(res?.data?.message);
        getUserProfile();
        setTimeout(() => window.location.reload(), 1000);

        return;
      }

      const uploadPromises = [];

      // --- Prepare brand_logo upload ---
      if (selectedFile) {
        uploadPromises.push(
          branding?.brand_logo?.upload_id
            ? useUpload(selectedFile, branding?.brand_logo?.upload_id)
            : useUpload(selectedFile)
        );
      } else {
        uploadPromises.push(null);
      }

      // --- Prepare school_stamp upload ---
      if (selectedStamp) {
        uploadPromises.push(
          branding?.school_stamp?.upload_id
            ? useUpload(selectedStamp, branding?.school_stamp?.upload_id)
            : useUpload(selectedStamp)
        );
      } else {
        uploadPromises.push(null);
      }

      // --- Run uploads in parallel ---
      const [logoRes, stampRes] = await Promise.all(uploadPromises);

      // --- Handle brand_logo response ---
      if (logoRes) {
        if (logoRes.status === 200 && logoRes.data.data) {
          updatedBranding.brand_logo = {
            file_url: logoRes.data.data?.[0]?.file_url,
            upload_id: logoRes.data.data?.[0]?.upload_id
          };
        } else {
          toast.error("Unable to upload brand logo");
          setIsEditing(false);

          return;
        }
      }

      // --- Handle school_stamp response ---
      if (stampRes) {
        if (stampRes.status === 200 && stampRes.data.data) {
          updatedBranding.school_stamp = {
            file_url: stampRes.data.data?.[0]?.file_url,
            upload_id: stampRes.data.data?.[0]?.upload_id
          };
        } else {
          toast.error("Unable to upload school stamp");
          setIsEditing(false);

          return;
        }
      }

      // --- Update branding with new values ---
      const res = await httprequest.patch(PROFILE_ENDPOINT, { branding: updatedBranding });

      setIsEditing(false);
      toast.success(res?.data?.message);
      getUserProfile();

      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } catch (err) {
      setIsEditing(false);
      toast.error(err?.response?.message || "Something went wrong");
    }
  };

  useEffect(() => {
    setBrandingDetails(data?.branding);
  }, []);

  return (
    <Grid container className={classes.bankingformbg}>
      <Grid item lg={6} md={12} sm={12} xs={12}>
        <div className="page-content all_padding">
          <Grid container spacing={2}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <div className={classes.brandflex}>
                <div className={classes.logouploadcontainer} style={{ backgroundImage: `url(${schoolLogo || branding?.brand_logo?.file_url || logo})` }}>
                </div>
                <div className={classes.brandesc}>
                  <h4 className={classes.title}>School Logo</h4>
                  <h6 className={classes.subtitle}>This Logo will be displayed on the dashboard</h6>
                  <button className={classes.selectimage}>
                    <Icon icon="heroicons:pencil-square-solid" className={classes.editpencil} />
                    Change Brand Image
                    <input type="file" className={classes.filepicker} onChange={handleFileChange} name="file" accept="image/jpeg,image/jpg,image/png" />
                  </button>
                  {selectedFile?.name && (
                    <div>
                      <p className={classes.uploadtitle}>{selectedFile?.name}</p>
                    </div>
                  ) }
                  {selectedFile?.name ? (
                    <div className={classes.removefile} onClick={handleRemoveFile}><Icon icon="zondicons:minus-solid" /> Remove File</div>
                  ) : null}
                </div>
              </div>
            </Grid>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <InputGroup inputType="text" label="Description" inputName="description" value={branding?.description} onChange={handleIdentityChange} />
            </Grid>
            <Grid item lg={6} md={6} sm={12} xs={12}>
              <InputGroup inputType="text" label="Website url" inputName="website_url" value={branding?.website_url} onChange={handleIdentityChange} />
            </Grid>
            <Grid item lg={6} md={6} sm={12} xs={12}>
              <InputGroup inputType="text" label="Facebook Url" inputName="facebook_url" value={branding?.facebook_url} onChange={handleIdentityChange} />
            </Grid>
            <Grid item lg={6} md={6} sm={12} xs={12}>
              <InputGroup inputType="text" label="Likedin Url" inputName="linkedin_url" value={branding?.linkedin_url} onChange={handleIdentityChange} />
            </Grid>
            <Grid item lg={6} md={6} sm={12} xs={12}>
              <InputGroup inputType="text" label="Instagram Url" inputName="instagram_url" value={branding?.instagram_url} onChange={handleIdentityChange} />
            </Grid>
            {data?.branding?.school_stamp?.file_url && (
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <div className={classes.signatureWrap}>
                  <div className={classes.header}>
                    <div className={classes.signatureLabel}>
                      School Stamp
                    </div>
                    <div>
                      <Icon onClick={handleDeleteStamp} icon="material-symbols:delete-outline" width="24" height="24" style={{ color: "#b20c0cff" }} />
                    </div>
                  </div>
                  <div className={classes.signatureCard}>
                    {data?.branding?.school_stamp?.file_url ? (
                      <img src={data?.branding?.school_stamp?.file_url} alt="Stamp" className={classes.signatureImg} />
                    ) : (
                      <div className={classes.signatureEmpty}>No stamp uploaded</div>
                    )}
                  </div>
                </div>
              </Grid>
            )}
            <Grid item lg={selectedStamp ? 10 : 12} md={12} sm={12} xs={12}>
              <label className={`${classes.label}`}><p>Upload/Update School Stamp</p> </label>
              <div className={classes.pickercontainer}>
                <input type="file" className={classes.picker} onChange={handleStampChange} name="file" accept="image/jpeg,image/jpg,image/png" />

                <div className={classes.uploadflex}>
                  <div><Icon icon="icon-park-outline:upload-two" className={classes.uploadicon} /></div>
                  {selectedStamp?.name ? (
                    <div>
                      <h2 className={classes.uploadtitle}>{selectedStamp?.name}</h2>
                    </div>
                  ) :
                    <div>
                      <p className={classes.uploadtitle}>Tap to Upload</p>
                      <p className={classes.uploadsubtitle}>JPG/PNG | 10MB max.
                      </p>
                    </div>}
                </div>
                <div className={classes.rightpicker}>
                  {selectedStamp?.name ? (
                    <div className={classes.uploadbutton} onClick={handleRemoveSTamp}><Icon icon="zondicons:minus-solid" /> Remove File</div>
                  ) : null}
                </div>
              </div>
            </Grid>
            <Grid item lg={2} md={2} sm={12} xs={12}>
              <div className={classes.previewGrid}>
                {selectedStamp && (
                  <div className={classes.previewItem}>
                    <img
                      src={URL.createObjectURL(selectedStamp)}
                      alt="preview"
                      className={classes.previewAnImage}
                    />
                    <div
                      className={classes.removeBtn}
                      onClick={() => handleRemoveSTamp()}
                    >
                      <Icon icon="zondicons:minus-solid" /> Remove
                    </div>
                  </div>
                )}
              </div>
            </Grid>
          </Grid>
          <div className={classes.btnspace}>
            <Button variant="primary" color="btndefault" buttonSize="medium" buttonName="Save Changes" onClick={handleBrandUpdate} isLoading={isEditing} />
          </div>
        </div>
      </Grid>
      <Grid item lg={6} md={4} sm={12} xs={12}>
        <div className={classes.brandingcontainer}>
          <h4 className={classes.title}>Choose a Brand Color</h4>
          <div className={classes.palettecontainer}>
            <SketchPicker
              color={brandColor}
              onChangeComplete={handleChangeBrandColor}
            />
          </div>
        </div>
      </Grid>
      {/* Delete Modal */}
      <Modal
        title="Delete School Stamp"
        subtitle="Are you sure you want to delete this school stamp? This action cannot be undone."
        modalContent={
          <>
            <div>
            </div>
          </>
        }
        modalFooter={
          <>
            <Button
              variant="danger"
              buttonName="Delete Stamp"
              buttonSize="full"
              color="btndefault"
              onClick={handleDeleteSchoolStamp}
              isLoading={isDeleting}
            />
          </>
        }
        isopen={deleteStamp}
        closeModal={handleDeleteStamp}
      />
      {/* <ToastContainer /> */}
    </Grid>
  );
};

export default BrandIdentity;
